module.exports = __webpack_public_path__ + "static/media/h_bottom_left.4362cd8b.png";